import { render, staticRenderFns } from "./termsfeed.vue?vue&type=template&id=0f861d14"
import script from "./termsfeed.vue?vue&type=script&lang=js"
export * from "./termsfeed.vue?vue&type=script&lang=js"
import style0 from "./termsfeed.vue?vue&type=style&index=0&id=0f861d14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports